import React from 'react';
import { Input } from 'antd';
import { useIntl } from 'react-intl';
import { SearchOutlined } from '@ant-design/icons';

const { Search } = Input;

type Props = React.ComponentProps<typeof Search>;
const SearchInput: React.FC<Props> = ({ onSearch, ...props }) => {
  const intl = useIntl();
  return (
    <Input
      css={`
        .ant-input-suffix {
          color: rgba(0, 0, 0, 0.25);
        }
      `}
      allowClear
      data-testid="search-input"
      suffix={<SearchOutlined />}
      onChange={(e) => {
        if (onSearch) {
          onSearch(e.target.value);
        }
      }}
      placeholder={intl.formatMessage({ defaultMessage: 'Search' })}
      {...props}
    />
  );
};

export default SearchInput;
